// 로그인·루트(/)·홈 "앱으로 이동" 착지 경로.
// 착지는 항상 CRM 대시보드(사용자 확정 2026-10-22) — 마지막 사용 제품을 기억하지 않는다.
const CRM_HOME = "/crm/dashboard";
const ITC_HOME = "/planning/documents";

/** 제품 첫 화면 경로 → 그 제품 영역에 진입할 때 검사하는 상단 메뉴 키(App.tsx crmArea/itcArea 와 같다). */
export const PRODUCT_MENU_KEY: Record<string, string> = {
  [CRM_HOME]: "topnav:CRM",
  [ITC_HOME]: "topnav:IT-CONSULTING",
};

/**
 * 착지 경로. CRM 대시보드가 기본.
 * canEnter 를 주면 권한 없는 제품은 건너뛴다 — CRM 권한이 없으면 IT-CONSULTING, 둘 다 없으면 /home.
 * (권한 없는 제품으로 보내면 RoleGuard 가 /home 으로 되돌려 "앱으로 이동"이 제자리를 돈다.)
 */
export function getLastProduct(canEnter?: (menuKey: string) => boolean): string {
  if (!canEnter) return CRM_HOME;
  for (const path of [CRM_HOME, ITC_HOME]) {
    if (canEnter(PRODUCT_MENU_KEY[path])) return path;
  }
  return "/home";
}

// 로그인 때문에 튕긴 원래 경로(딥링크). 세션 탭 한정 1회용.
const NEXT_KEY = "vault-login-next";

/** AuthGuard가 /login으로 보내기 직전, 원래 가려던 경로를 기록. */
export function setLoginNext(path: string): void {
  try {
    sessionStorage.setItem(NEXT_KEY, path);
  } catch {
    /* storage 차단 환경 — 무시 */
  }
}

/** 로그인 직후 착지 경로 — 튕긴 원래 경로가 있으면 그곳(소비), 없으면 CRM 대시보드. */
export function takeLoginNext(): string {
  try {
    const next = sessionStorage.getItem(NEXT_KEY);
    sessionStorage.removeItem(NEXT_KEY);
    // 오픈 리다이렉트 차단 — 같은 앱 내부 경로만 허용("//" 는 프로토콜 상대 URL)
    if (next && next.startsWith("/") && !next.startsWith("//")) return next;
  } catch {
    /* storage 차단 환경 — 무시 */
  }
  return getLastProduct();
}
